export default class {

    init(Livewire) {
        window.loadingImage = '<img width="12" height="12" src="/images/ajax-loader.gif"/>';

        if (!window.livewireHooksInitialized) {
            window.livewireHooksInitialized = true;

            Livewire.hook('commit', ({component, commit, respond, succeed, fail}) => {

                let activeElement = document.activeElement;
                if (activeElement.tagName.toLowerCase() === 'button' && activeElement.hasAttribute('data-livewire-button-loading')) {
                    window.$livewireBtnLoading = $(activeElement);
                    window.livewireBtnLoadingText = activeElement.innerHTML;
                    window.$livewireBtnLoading.html(window.loadingImage);
                    window.$livewireBtnLoading.attr('disabled', true).prop('disabled', true);
                }

                succeed(({snapshot, effect}) => {
                    if (activeElement.tagName.toLowerCase() === 'button' && activeElement.hasAttribute('data-livewire-button-loading')) {
                        window.$livewireBtnLoading.html(window.livewireBtnLoadingText);
                        window.$livewireBtnLoading.attr('disabled', false).prop('disabled', false);
                    }
                })

            })
        }
    }
}
